import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import { useState } from 'preact/hooks'
import Sidebar from "./Sidebar"
import Icon from "./elements/Icon"
import Select from "./elements/Select"

function ToggleMobileSidebarButton({ selectedFiltersCount, className, handleCheckboxChange }) {
    const id = "toggle-mobile-sidebar"

    return (
        <>
        <input type="checkbox" id={id} class="ns-facet-sidebar-toggle ns-d-none" onChange={handleCheckboxChange}/>
        <label
            for={id}
            className={`ns-act-btn ns-btn-filter-mobile ns-filters ns-d-md-none ${className}`}
        >
           Filter
        </label>
        </>
    )
}

export default function Toolbar({ mobile }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const [sidebarChecked, setSidebarChecked] = useState(false);
    const handleCheckboxChange = () => {
        setSidebarChecked(!sidebarChecked);
    };

    return (
        <div
            class={
                mobile
                    ? "ns-mobile-header-controls ns-collection-toolbar ns-d-flex ns-d-md-none"
                    : "ns-header-controls ns-d-none ns-flex-wrap align-center ns-justify-content-between ns-d-md-flex ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            }
            style={loading ? "opacity: 0.3; justify-content: end !important;" : `${sidebarChecked ? 'z-index: 20 !important' : ''}` }
        >
            {!loading && !mobile && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    { totalSummary }
                </span>
            )}
            <div
                class={
                    mobile
                        ? "ns-toolbar-item-mobile ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block ns-w-100"
                        : "ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block"
                }
            >
                {mobile && (
                    <>
                        <ToggleMobileSidebarButton selectedFiltersCount={selectedFiltersCount} handleCheckboxChange={handleCheckboxChange} />
                        <Sidebar mobile />
                    </>
                )}
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                /> */}
            </div>
        </div>
    )
}
